import { toast } from "react-toastify";
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import Cookies from "js-cookie";

// const { persist, purge } = configurePersist({
//   storage: localStorage, // use `AsyncStorage` in react native
//   rootKey: "root", // optional, default value is `root`
// });


const getToken = () => {
  // const authStore = JSON.parse(localStorage.getItem("auth-storage"))
  // const token = authStore?.state?.token
  // // console.log(authStore)
  // const decoded = token && jwtDecode(token)
  // // console.log((new Date().getTime()) > ((decoded?.exp) * 1000))
  // // console.log(Date.now())
  // if (((Date.now()) > ((decoded?.exp) * 1000))) {
  //   // console.log("test")
  //   localStorage.removeItem("auth-storage")
  //   window.location.reload()
  //   return null
  // } else {
  //   return token
  // }
  return Cookies.get("access_token")
}
export const useAuthStore = create(
  persist(
    (set) => ({
      isAuthenticating: false,
      isAuthenticated: false,
      loader: false,
      token: getToken(),
      user: null,
      isPilot: false,
      setLoaderState: (state) => {
        set({ loader: state })
      },
      addUser: (user) => {
        set({ user: user });
      },
      setIsPilot: (bool) => {
        set({ isPilot: bool })
      },
      setToken: (token) => {
        set({ token: token });
      },
      logout: () => {
        set({ token: null, user: null })
      },
      toast: (type, message) => {
        switch (type) {
          case "success":
            toast.success(message)
            break;
          case "error":
            toast.error(message)
            break
          case "info":
            toast.info(message)
            break;
          default:
            break;
        }
      }
    }),
    {
      name: "auth-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

// export default useAuthStore;
